import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';

export const getServiceRequest = async (serviceRequestId: string) => {
  try {
    const res = await fetcher(
      `${API_BASE_PATH}/${serviceRequestId}`,
      {
        method: 'GET',
      },
      undefined
    );

    return res.json();
  } catch (error) {
    console.error(error);
    throw error;
  }
};
